import request from 'services/request';
import { endpoints } from 'services/endpoints';

export default {
  /** 회원 탈퇴 처리 */
  postWithdraw: (params: WithdrawalConfirmReqDto): Promise<BaseResDto> => {
    return request({
      url: endpoints.withdrawal.withdraw,
      method: 'post',
      data: params,
    });
  },
  /** 회원 탈퇴 전 비밀번호 검증 */
  postWithdrawalPasswordConfirm: (params: WithdrawalConfirmReqDto): Promise<BaseResDto> => {
    return request({
      url: endpoints.withdrawal.withdrawalPasswordConfirm,
      method: 'post',
      data: params,
    });
  },
};
